import React from 'react';
import LoginComponent from '../components/auth/LoginComponent';

const Login = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <LoginComponent />
    </div>
  );
};

export default Login;